// The preview and save must use the same dates, tariffs and manual prices.
export function bookingEditPayload(form) {
  const payload = {
    customer_override: form.customer_override || {},
    use_weekend_rate: !!form.use_weekend_rate,
    notes: form.notes,
    additional_drivers: form.additional_drivers || [],
  };
  for (const key of ['customer_id', 'vehicle_id', 'start_date', 'end_date']) {
    if (form[key]) payload[key] = form[key];
  }
  for (const key of ['pickup_location', 'return_location']) {
    if (form[key] !== undefined) payload[key] = form[key];
  }
  for (const key of ['pickup_mileage', 'deposit_amount', 'insurance_deductible', 'manual_daily_rate', 'manual_base_price', 'manual_extras_price', 'manual_total_price']) {
    if (form[key] !== '' && form[key] != null) {
      payload[key] = (key === 'pickup_mileage' ? parseInt(form[key], 10) : parseFloat(form[key])) || 0;
    }
  }
  if (form.manual_price_note) payload.manual_price_note = form.manual_price_note;
  for (const key of ['included_km', 'extra_km_rate']) {
    payload[key] = form[key] === '' || form[key] == null ? null : (key === 'included_km' ? parseInt(form[key], 10) : parseFloat(form[key])) || 0;
  }
  return payload;
}
